import React from "react";
import InnerInput from "components/inputs/InnerInput/InnerInput";
import SwitchBtn from "components/buttons/SwitchBtn";

interface Props {
  payloadGroup: any;
  onChange: (key: string, value: string | boolean | number) => void;
  readOnly?: boolean;
  t: (key: string) => string;
}

const CmsBannersMainTab: React.FC<Props> = ({ payloadGroup, onChange, readOnly, t }) => {
  return (
    <div className="banners-form-wrapper banners-group">
      <div className="banners-form-item">
        <InnerInput
          value={payloadGroup?.title ?? ""}
          placeholder={t("title")}
          label={t("title")}
          type="text"
          id="banners-title"
          onChange={(e) => onChange("title", e)}
          disabled={readOnly}
        />
      </div>

      <div className="banners-form-item">
        <SwitchBtn
          activeTxt={t("active")}
          isActive={!!payloadGroup?.isActive}
          handleClick={() =>
            onChange(
              "isActive",
              payloadGroup?.isActive ? !payloadGroup?.isActive : true,
            )
          }
          disabled={readOnly}
        />
      </div>
    </div>
  );
};

export default CmsBannersMainTab;
